import { PermissionType, Resource } from '@repo/common';

export function generatePermissionType(
    resource: Resource | string,
    permission: PermissionType | string,
): string {
    return `${resource}__${permission}`;
}

export function generatePermissionTypeAll(resource: Resource): string[] {
    return [
        `${resource}__${PermissionType.Create}`,
        `${resource}__${PermissionType.Read}`,
        `${resource}__${PermissionType.Update}`,
        `${resource}__${PermissionType.Delete}`,
    ];
}
